import { createContext, useContext } from 'react';

import {
	TBankStatementsData,
	TDebtScheduleData,
	THandoffMode,
	TUploadAttachmentsData,
} from '@/shared/types';

type TFlowsControllerContext = {
	bankStatementData: TBankStatementsData | null;
	setBankStatementData: (state: TBankStatementsData | null) => void;
	debtScheduleData: TDebtScheduleData | null;
	setDebtScheduleData: (state: TDebtScheduleData | null) => void;
	isContinuationOfTheMainFlow: boolean;
	uploadAttachmentsData: TUploadAttachmentsData | null;
	setUploadAttachmentsData: (data: TUploadAttachmentsData | null) => void;
	setIsContinuationOfTheMainFlow: (isContinuation: boolean) => void;
	handoffMode: THandoffMode | null;
	setHandoffMode: (handoffMode: THandoffMode | null) => void;
};

export const FlowsControllerContext = createContext<TFlowsControllerContext | undefined>(undefined);

export const useFlowsControllerContext = (): TFlowsControllerContext => {
	const context = useContext(FlowsControllerContext);

	if (!context) {
		throw new Error('useFlowsControllerContext must be used within an FlowsControllerProvider');
	}

	return context;
};
